module.exports = __webpack_public_path__ + "images/98a143b10fec7f4d6bd93842e98a512b-logo_white.png";